import { BRAND_LOGO } from '@/constants';
import { ProLayoutProps } from '@ant-design/pro-components';

const Settings: ProLayoutProps = {
  logo: BRAND_LOGO,
  layout: 'mix',
  fixSiderbar: true,
  breakpoint: 'md',
  menu: {
    locale: false,
  },
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    // https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
};

export default Settings;
